/**
 * «Сборка отстала от того, что раздаёт конфиг» — один флаг на вкладку.
 *
 * Живёт вне React потому, что читать его нужно из `queryClient`, а тот создаётся модулем и о
 * компонентах ничего не знает. Пишет сюда `useAppUpdateGate` после каждой удачной проверки.
 *
 * Смысл ровно один: правильно назвать причину, когда шлюз отклонил запрос на валидации.
 * Устарели — «обновите приложение»; версия свежая — значит это наш баг, и звать в стор нельзя.
 */
let outdated = false;

export const setBuildOutdated = (value: boolean) => {
  outdated = value;
};

export const isKnownOutdated = () => outdated;
